import type { GlobalSharedValidationErrorsResponse } from '@ori/global-api-client-react';

export enum HttpStatusCodes {
  OK = 200,
  NotFound = 404,
  Forbidden = 403,
  InternalServerError = 500,
}

export class FetchResult<TResponse = unknown> {
  httpStatus: HttpStatusCodes;

  response?: TResponse;

  constructor(httpStatus: HttpStatusCodes, response?: TResponse) {
    this.httpStatus = httpStatus;
    this.response = response;
  }

  isSuccess(): boolean {
    return FetchResult.isSuccess(this.httpStatus);
  }

  static get error(): FetchResult<GlobalSharedValidationErrorsResponse> {
    return new FetchResult<GlobalSharedValidationErrorsResponse>(HttpStatusCodes.InternalServerError, { errors: [] });
  }

  static get errorFor(): <TErrorResponse>(response: TErrorResponse) => FetchResult<TErrorResponse> {
    return (response) => new FetchResult(HttpStatusCodes.InternalServerError, response);
  }

  static isSuccess(...httpStatuses: HttpStatusCodes[]): boolean {
    const minSuccessCode = 200;
    const maxSuccessCode = 299;

    return httpStatuses.every((status) => status >= minSuccessCode && status <= maxSuccessCode);
  }

  static isAllSuccess(...results: Array<FetchResult | undefined>): boolean {
    return results.every((r) => r === undefined || r.isSuccess());
  }
}
